import map_marker_boulder from '../../../../javascript/images/map_marker_boulder.png'
import map_marker_boulder_active from '../../../../javascript/images/map_marker_boulder_active.png'
import map_marker_dws from '../../../../javascript/images/map_marker_dws.png'
import map_marker_dws_active from '../../../../javascript/images/map_marker_dws_active.png'
import map_marker_trad from '../../../../javascript/images/map_marker_trad.png'
import map_marker_trad_active from '../../../../javascript/images/map_marker_trad_active.png'
import sport from '../../../../javascript/images/map_marker_sport.png'
import sport_active from '../../../../javascript/images/map_marker_sport_active.png'
import parking from '../../../../javascript/images/parking.png'

window.MapMarkerViews = {
  saved: '<h3>Thanks for your contribution!</h3><p>The map marker was successfully saved.</p>',
  error: '<h3>Sorry, something went wrong.</h3><p>Please, reload the page and try again.</p>'
};

window.MapMarkerIcons = {
  dws: function() {
    return {
      url: map_marker_dws,
      url_default: map_marker_dws,
      url_highlight: map_marker_dws_active,
      size: new google.maps.Size(40, 40),
    };
  },
  trad: function() {
    return {
      url: map_marker_trad,
      url_default: map_marker_trad,
      url_highlight: map_marker_trad_active,
      size: new google.maps.Size(40, 40),
    };
  },
  boulder: function() {
    return {
      url: map_marker_boulder,
      url_default: map_marker_boulder,
      url_highlight: map_marker_boulder_active,
      size: new google.maps.Size(40, 40),
    };
  },
  sport: function() {
    return {
      url: sport,
      url_default: sport,
      url_highlight: sport_active,
      size: new google.maps.Size(40, 40),
    };
  },
  parking_space: function() {
    return {
      url: parking,
      size: new google.maps.Size(22, 22),
      anchor: new google.maps.Point(11, 11)
    };
  }
};
